function decimalFromString(value) {
    if (!value) return 0;
    return parseFloat(value.toString().replace(/\./g, '').replace(',', '.')) || 0;
}


function decimalFromTimeString(horaString) {
    if (!horaString || horaString.length != 5) return 0;
    const [horas, minutos] = horaString.split(":").map(Number);
    return horas + minutos / 60;
}


function formatCNAE(v) {
    if (!v) return '';
    v = v.replace(/\D/g, '').padStart(7, '0');
    return `${v.slice(0,4)}-${v.slice(4,5)}/${v.slice(5)}`;
}


function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
}


function formatDateFromJson(dataStr){
    if (!dataStr) return '';
    const datePart = dataStr.includes('T') ? dataStr.split('T')[0] : dataStr;
    const [year, month, day] = datePart.split('-');
    return `${day}/${month}/${year}`;
}


function formatDateTimeFromJson(dataStr) {
    if (!dataStr) return '';
    const [datePart, timePart] = dataStr.includes('T') ? dataStr.split('T') : [dataStr, ''];
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':');
    return `${day}/${month}/${year} ${hour}:${minute}`;
}


function formatDecimal(value) {
    if (value===0) return '0,00';
    if (!value) return '';
    return parseFloat(value.toString().replace(',', '.')).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}


function formatInteger(value) {
    if (value===0) return '0';
    if (!value) return '';
    return parseInt(value).toLocaleString('pt-BR');
}


function formatTimeFromDecimal(value){
    if (value === 0){return '00:00';}
    let hours = Math.floor(value);
    let minutes = Math.round((value - hours) * 60);
    if (minutes === 60) {
        hours++;
        minutes = 0;
    }
    const hoursStr = String(hours).padStart(2, '0');
    const minutesStr = String(minutes).padStart(2, '0');
    return `${hoursStr}:${minutesStr}`;
}


function formatTimeFromJson(value){
    if (!value) return '';
    return String(value).substring(0,5);
}


function getId(obj) {
    // 14-07-25: FUNÇÃO QUE RETORNA "ID" DO OBJETO PARA PADRONIZAÇÃO NOS FORMULÁRIOS
    return obj?.id ?? 0;
}


function getIntervaloMes(mes, ano) {
    const mesAjustado = mes - 1; // porque o JS começa os meses em 0
    const primeiroDia = new Date(ano, mesAjustado, 1);
    const ultimoDia = new Date(ano, mesAjustado + 1, 0);
  
    const formatarData = (data) => data.toISOString().split('T')[0];

    return {
        datainicial: formatarData(primeiroDia),
        datafinal: formatarData(ultimoDia)
    }
}


function integerFromString(value) {
    if (!value) return 0;
    return parseInt(value.toString().replace(/\./g, '')) || 0;
}


function parseDataInput(dataStr) {
    if (!dataStr) return null;
    // Caso ISO (YYYY-MM-DD ou YYYY-MM-DDTHH:mm:ss)
    if (/^\d{4}-\d{2}-\d{2}/.test(dataStr)) {
        return dataStr.split('T')[0];
    }

    // Caso brasileiro (DD/MM/YYYY)
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataStr)) {
        const [dia, mes, ano] = dataStr.split('/');
        return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
    }
    return null;

    // if (dataStr.includes('-')) {
    //     return dataStr.split('T')[0];
    // }
    // if (dataStr.includes('/')) {
    //     const [dia, mes, ano] = dataStr.split('/');
    //     return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
    // }
    // return '';
}


function parseDataLocal(dataStr) {
    if (!dataStr) return null;

    // Se já vier como Date
    if (dataStr instanceof Date) {
        return dataStr;
    }

    // Se vier como number, converte para string
    if (typeof dataStr !== 'string') {
        dataStr = String(dataStr);
    }

    // Esperado: yyyy-MM-dd
    const partes = dataStr.split('-');

    if (partes.length !== 3) {
        return null;
    }

    const [ano, mes, dia] = partes.map(Number);

    if (!ano || !mes || !dia) {
        return null;
    }

    return new Date(ano, mes - 1, dia);
}


function strDataAtual(){
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    return `${day}/${month}/${year}`;
}


function strDataHoraAtual(){
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
}


function validarCNPJ(cnpj) {
    if (!cnpj) throw new Error('CNPJ não informado')

    const cleaned = cnpj.replace(/\D/g, '')
    if (cleaned.length !== 14) throw new Error('CNPJ deve conter 14 dígitos')

    if (/^(\d)\1{13}$/.test(cleaned)) throw new Error('CNPJ inválido')

    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    const pesos2 = [6, ...pesos1]

    const calcularDigito = (base, pesos) => {
        const soma = base.reduce((acc, num, i) => acc + num * pesos[i], 0)
        const resto = soma % 11
        return resto < 2 ? 0 : 11 - resto
    }

    const numeros = cleaned.split('').map(Number)
    const base = numeros.slice(0, 12)
    const digito1 = calcularDigito(base, pesos1)
    const digito2 = calcularDigito([...base, digito1], pesos2)

    if (digito1 !== numeros[12] || digito2 !== numeros[13]) {
        throw new Error('CNPJ inválido')
    }
}


function validarCNPJouCPF(dados){
    if (!dados) throw new Error('CPF/CNPJ não informado');
    const cleaned = dados.replace(/\D/g, '');
    (cleaned.length > 11) ? validarCNPJ(dados) : validarCPF(dados);
}


function validarCPF(cpf) {
    if (!cpf) throw new Error('CPF não informado')

    const cleaned = cpf.replace(/\D/g, '')
    if (cleaned.length !== 11) throw new Error('CPF deve conter 11 dígitos')

    if (/^(\d)\1{10}$/.test(cleaned)) throw new Error('CPF inválido')

    let soma = 0
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cleaned.charAt(i)) * (10 - i)
    }
    let resto = (soma * 10) % 11
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== parseInt(cleaned.charAt(9))) throw new Error('CPF inválido')

    soma = 0
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cleaned.charAt(i)) * (11 - i)
    }
    resto = (soma * 10) % 11
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== parseInt(cleaned.charAt(10))) throw new Error('CPF inválido')
}


function validarData(dataStr, options = {}) {
    const {
        diasMinimos = null,
        diasMaximos = null,
        dataMinima = null,
        dataMaxima = null,
        nomeCampo = null,
    } = options;
    const prefixo = (nomeCampo) ? `${nomeCampo}: ` : '';

    if (!dataStr) throw new Error(`${prefixo}Data não informada`);

    const dataInformada = parseDataLocal(dataStr);
    dataInformada.setHours(0, 0, 0, 0);

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    // Validação mínima relativa
    if (diasMinimos !== null) {
        const limiteMin = new Date(hoje);
        limiteMin.setDate(limiteMin.getDate() + diasMinimos);
        if (dataInformada < limiteMin) {
            throw new Error(`${prefixo}A data deve ser igual ou superior a ${formatDate(limiteMin)}`);
        }
    }

    // Validação máxima relativa
    if (diasMaximos !== null) {
        const limiteMax = new Date(hoje);
        limiteMax.setDate(limiteMax.getDate() + diasMaximos);
        if (dataInformada > limiteMax) {
            throw new Error(`${prefixo}A data deve ser igual ou inferior a ${formatDate(limiteMax)}`);
        }
    }

    // Validação mínima absoluta
    if (dataMinima !== null) {
        const limiteAbsMin = new Date(dataMinima);
        limiteAbsMin.setHours(0, 0, 0, 0);
        if (dataInformada < limiteAbsMin) {
            throw new Error(`${prefixo}A data deve ser igual ou superior a ${formatDate(limiteAbsMin)}`);
        }
    }

    // Validação máxima absoluta
    if (dataMaxima !== null) {
        const limiteAbsMax = new Date(dataMaxima);
        limiteAbsMax.setHours(0, 0, 0, 0);
        if (dataInformada > limiteAbsMax) {
            throw new Error(`${prefixo}A data deve ser igual ou inferior a ${formatDate(limiteAbsMax)}`);
        }
    }

    return true;
}


function validarHora(hora) {
    if (!hora) throw new Error('Hora não informada');
    const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!regex.test(hora)) throw new Error('Informe corretamente a hora');
}


function validarIntervaloDatas(startDate, endDate, obrigatorio = true) {
    if (!startDate || !endDate) {
        if (obrigatorio){throw new Error('Necessário informar ambas as datas.')} else {return}
    }

    const dataInicio = new Date(startDate);
    const dataFim = new Date(endDate);

    if (isNaN(dataInicio.getTime()) || isNaN(dataFim.getTime())) {
        throw new Error('Datas inválidas. Verifique o formato das datas.')
    }

    if (dataFim < dataInicio) {
        throw new Error('A data final deve ser maior ou igual à data inicial.')
    }
}


function validarNumeroPositivo(valor, msg = 'Valor inválido', prefixo = '') {
    if (valor === null || valor === undefined || valor === '') {
        throw new Error(prefixo ? `${prefixo}: ${msg}` : msg);
    }

    if (Funcoes.decimalFromString(valor) <= 0) {
        throw new Error(prefixo ? `${prefixo}: ${msg}` : msg);
    }
}


function validarTexto(valor, options = {}) {
    const {
        minText = null,
        nomeCampo = null,
    } = options;
    const prefixo = (nomeCampo) ? `${nomeCampo}: ` : '';

    if (!valor || String(valor).trim() === '') {        
        throw new Error(`${prefixo}Nenhuma informação preenchida`);
    }

    if (minText !== null && String(valor).trim().length < minText) {        
        throw new Error(`${prefixo}Informação deve conter mínimo de ${formatInteger(minText)} caracteres`);
    }
}



export const Funcoes = {
    decimalFromString,
    decimalFromTimeString,
    formatCNAE,
    formatDate,
    formatDateFromJson,
    formatDateTimeFromJson,
    formatDecimal,
    formatInteger,
    formatTimeFromDecimal,
    formatTimeFromJson,
    getId,
    getIntervaloMes,
    integerFromString,
    parseDataInput,
    parseDataLocal,
    strDataAtual,
    strDataHoraAtual,
    validarCNPJ,
    validarCNPJouCPF,
    validarCPF,
    validarData,
    validarHora,
    validarIntervaloDatas,
    validarNumeroPositivo,
    validarTexto,
}